<template>
  <div class="user-wrp">
    <div class="result-bracket__title user__list-count">
      <span class="result-bracket__count">{{ offers.length }} </span> Offer Found !
    </div>
  <div class="user__list-offer">
    <div class="user__list-offer__item" v-for="offer in offers" :key="offer.id">
      <p class="user__list-date"> {{ offer.date }}</p>
      <div class="user__list__dorm">
        <div class="user__list__dorm-img-wrp">
          <img :src="offer.logo" class="user__list__dorm-img" alt="">
        </div>
        <div class="user__list__dorm-wrp">
          <p class="user__list__dorm-name">{{ offer.name }}</p>
          <span class="user__list__dorm-location">
                   <img class="user__list__dorm-location-svg" src="@/assets/img/pin.svg"/>
                  {{ offer.location }}</span>
        </div>
        <div class="user__list-btn">
          <v-button
            class="fw shadow-none login-box__submit"
            :class="offer.state ? 'green' : 'gray'"
            :title="offer.state ? 'OFFER HAS COME' : 'AWAITING PROPOSAL'"
          />
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: 'Offers',
  data () {
    return {
      offers: [],
      offers1: [
        {
          id: 0,
          date: '18 Mart 2018',
          logo: require('@/assets/img/campuscity-logo.png'),
          name: 'Academia Seyrantepe Kız Öğrenci Yurdu',
          location: 'Kartal, İstanbul',
          state: true

        },
        {
          id: 1,
          date: '18 Mart 2018',
          logo: require('@/assets/img/campuscity-logo.png'),
          name: 'Academia Seyrantepe Kız Öğrenci Yurdu',
          location: 'Kartal, İstanbul',
          state: true

        },
        {
          id: 2,
          date: '18 Mart 2018',
          logo: require('@/assets/img/campuscity-logo.png'),
          name: 'Academia Seyrantepe Kız Öğrenci Yurdu',
          location: 'Kartal, İstanbul',
          state: false

        },
        {
          id: 3,
          date: '18 Mart 2018',
          logo: require('@/assets/img/campuscity-logo.png'),
          name: 'Academia Seyrantepe Kız Öğrenci Yurdu',
          location: 'Kartal, İstanbul',
          state: true

        },
        {
          id: 4,
          date: '18 Mart 2018',
          logo: require('@/assets/img/campuscity-logo.png'),
          name: 'Academia Seyrantepe Kız Öğrenci Yurdu',
          location: 'Kartal, İstanbul',
          state: false

        }
      ]
    }
  },
  methods: {
    getOffers () {
      let self = this
      axios.get(`/user/offers`)
        .then(response => {
          self.offers = response.data.offers
        })
        .catch(e => {
          self.errors.push(e)
        })
    },    
  },
  mounted () {
    this.getOffers()
  },    

}
</script>

<style scoped lang="scss">
  @import "../assets/scss/components/offers";
</style>
